import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import {
    Col,
    Container,
    Row,
    Form,
    CardBody,
    Card,
    Label,
    Input,
    Button,
    Table,
    Modal,
    ModalBody,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Progress,
} from "reactstrap";
import * as Yup from "yup";
import classnames from "classnames";
import { useDispatch } from "react-redux";
import { getAuthMe } from "../../../slices/auth/user/thunk";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import EditPhoneNumberModal from "Components/Common/EditPhoneNumberModal";
import { getSeller } from "live-slices/thunk";
import { useNavigate } from "react-router-dom";

const AccountSetting = (props: any) => {
    document.title = "Account Setting | BuyPass";

    const [modal, setModal] = useState<boolean>(false);
    const [progressbarvalue, setprogressbarvalue] = useState<number>(0);
    const [activeTab, setactiveTab] = useState<number>(1);
    const [passedSteps, setPassedSteps] = useState<any>([1]);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [editPhoneNumModal, setEditPhoneNumModal] = useState(false);
    const [hasFetched, setHasFetched] = useState(false)
    const [shouldFetch, setShouldFetch] = useState(true);
    const navigate = useNavigate();

    const [activeModal, setActiveModal] = useState<string | null>(null);

    const handleOpenModal = (modalType: string) => {
        setActiveModal(modalType);
        setModal(true);
        setIsEdit(false);
    };

    const toggle = useCallback(() => {
        setModal(!modal);
        if (!modal) setActiveModal(null);
    }, [modal]);


    function toggleTab(tab: any, value: any) {
        if (activeTab !== tab) {
            var modifiedSteps = [...passedSteps, tab];

            if (tab >= 1 && tab <= 4) {
                setactiveTab(tab);
                setPassedSteps(modifiedSteps);
            }
        }
        setprogressbarvalue(value);
    }
    const dispatch: any = useDispatch();
    const selectuserProfile = createSelector(
        (state: any) => state.Business,
        (business) => business?.business
    );
    const seller = useSelector(selectuserProfile);

    useEffect(() => {
        if (seller?._id && shouldFetch && !hasFetched) {
            dispatch(getSeller(seller._id));
            setHasFetched(true);
            setShouldFetch(false);
        }
    }, [seller, hasFetched, dispatch, shouldFetch])

    const closeModal = () => {
        setEditPhoneNumModal(false);
        setShouldFetch(true);
    };

    const selectUser = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );

    const user = useSelector(selectUser);

    useEffect(() => {
    }, [user]);


    return (
        <div className="page-content">

            <EditPhoneNumberModal
                show={editPhoneNumModal}
                onCloseClick={closeModal}
            />

            <Container fluid>
                <BreadCrumb title="Account Setting" pageTitle="My-Account" pageTitleRoute="/my-account-setting" />
                <Card>
                    <CardBody className="rounded-3">
                        <div className="mb-2">
                            <h6 className="fw-bold ">Login Email address</h6>
                            <p>{seller?.email || "--"}
                                {/* <span className="text-success cursor-pointer" onClick={() => handleOpenModal("email")}>Modify</span> */}
                            </p>
                        </div>
                        <div className="mb-2">
                            <h6 className="fw-bold ">Login Phone Number</h6>
                            <p>{seller?.phoneNumber || "--"}
                                <span className="text-success cursor-pointer" onClick={() => setEditPhoneNumModal(true)}>Modify</span>
                            </p>
                        </div>
                        {/* <div >
                            <h6 className="fw-bold ">Password
                                <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span>
                            </h6>
                            <p>******
                                <span className="text-success cursor-pointer" onClick={()=> navigate('/pages-profile-settings')}>Modify</span>
                            </p>
                        </div> */}
                        <div >
                            <h6 className="fw-bold ">Password
                                <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span>
                            </h6>
                            <p>*****
                                <a
                                    className="text-success cursor-pointer"
                                    href="/change-password"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "none" }}
                                >
                                    Modify
                                </a>
                            </p>
                        </div>
                    </CardBody>
                </Card>



                {activeModal === "email" && (
                    <Modal isOpen={modal} toggle={toggle} centered>
                        <ModalBody>
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <h4>Login Email Address Modification</h4>
                                <i className="bx bx-x fs-3 cursor-pointer" onClick={toggle}></i>
                            </div>
                            <div className="progress-nav mb-5 w-50 mx-auto">
                                <Progress
                                    value={progressbarvalue}
                                    style={{ height: "1px" }}
                                />

                                <Nav
                                    className="nav-pills progress-bar-tab custom-nav"
                                    role="tablist"

                                >
                                    <NavItem>
                                        <NavLink
                                            to="#"
                                            id="pills-gen-info-tab"
                                            className={classnames(
                                                {
                                                    active: activeTab === 1,
                                                    done: activeTab <= 4 && activeTab >= 0,
                                                },
                                                "rounded-pill"
                                            )}
                                            onClick={() => {
                                                toggleTab(1, 0);
                                            }}
                                            tag="button"
                                        >
                                            <div className="p-0  mt-2">1</div>
                                            <h6 className="mt-1  d-block fw-bold ms " >
                                                Please verify your account
                                            </h6>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            to="#"
                                            id="pills-gen-info-tab"
                                            className={classnames(
                                                {
                                                    active: activeTab === 2,
                                                    done: activeTab <= 4 && activeTab > 1,
                                                },
                                                "rounded-pill"
                                            )}
                                            onClick={() => {
                                                toggleTab(2, 100);
                                            }}
                                            tag="button"
                                        >
                                            <div className="p-0  mt-2">2</div>
                                            <h6 className="mt-1  fw-bold " >Change the email
                                            </h6>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId={1}>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}>
                                        <p className="m-0">Your current login phone</p>
                                        <p className="m-0 py-1">+92 3242554868</p>

                                        <Label htmlFor="addressDetails" className="form-label">
                                            <p className="m-0">Verification Code in SMS</p>
                                        </Label>
                                        <div className="d-flex w-75 aling-items-center mb-">
                                            <Input
                                                type="text"
                                                name="addressDetails"
                                                className="me-2"
                                                id="addressDetails"
                                                placeholder="Enter the code"
                                            />
                                            <button type="button" className="btn btn-outline-success">Send</button>
                                        </div>
                                        <p className="text-success"><span><i className="bx bx-envelope-open"></i></span> Verify via login email address</p>

                                    </Form>


                                </TabPane>

                                <TabPane tabId={2}>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}>
                                        tab2
                                    </Form>
                                </TabPane>
                            </TabContent>
                            <div className="hstack gap-2 justify-content-end">
                                <button type="button" className="btn btn-light" onClick={() => setModal(false)}>Previous</button>
                                <button type="submit" className="btn btn-success" id="addNewMember" onClick={() => { toggleTab(activeTab + 1, 100); }}>{!isEdit ? "Next" : "Save"}</button>
                            </div>
                        </ModalBody>
                    </Modal>
                )}

                {activeModal === "phone" && (
                    <Modal isOpen={modal} toggle={toggle} centered>
                        <ModalBody>
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <h4>Login Phone Number Modification</h4>
                                <i className="bx bx-x fs-3 cursor-pointer" onClick={toggle}></i>
                            </div>
                            <div className="progress-nav mb-5 w-50 mx-auto">
                                <Progress
                                    value={progressbarvalue}
                                    style={{ height: "1px" }}
                                />

                                <Nav
                                    className="nav-pills progress-bar-tab custom-nav"
                                    role="tablist"

                                >
                                    <NavItem>
                                        <NavLink
                                            to="#"
                                            id="pills-gen-info-tab"
                                            className={classnames(
                                                {
                                                    active: activeTab === 1,
                                                    done: activeTab <= 4 && activeTab >= 0,
                                                },
                                                "rounded-pill"
                                            )}
                                            onClick={() => {
                                                toggleTab(1, 0);
                                            }}
                                            tag="button"
                                        >
                                            <div className="p-0  mt-2">1</div>
                                            <h6 className="mt-1 w-100 fw-bold ">Please verify your account
                                            </h6>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            to="#"
                                            id="pills-gen-info-tab"
                                            className={classnames(
                                                {
                                                    active: activeTab === 2,
                                                    done: activeTab <= 4 && activeTab > 1,
                                                },
                                                "rounded-pill"
                                            )}
                                            onClick={() => {
                                                toggleTab(2, 100);
                                            }}
                                            tag="button"
                                        >
                                            <div className="p-0  mt-2">2</div>
                                            <h6 className="mt-1 w-100 fw-bold ">Change the email
                                            </h6>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId={1}>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}>
                                        <p className="m-0">Your current login phone</p>
                                        <p className="m-0 py-1">+92 3242554868</p>

                                        <Label htmlFor="addressDetails" className="form-label">
                                            <p className="m-0">Verification Code in SMS</p>
                                        </Label>
                                        <div className="d-flex w-75 aling-items-center mb-">
                                            <Input
                                                type="text"
                                                name="addressDetails"
                                                className="me-2"
                                                id="addressDetails"
                                                placeholder="Enter the code"
                                            />
                                            <button type="button" className="btn btn-outline-success">Send</button>
                                        </div>
                                        <p className="text-success"><span><i className="bx bx-envelope-open"></i></span> Verify via login email address</p>

                                    </Form>


                                </TabPane>

                                <TabPane tabId={2}>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}>
                                        tab2
                                    </Form>
                                </TabPane>
                            </TabContent>
                            <div className="hstack gap-2 justify-content-end">
                                <button type="button" className="btn btn-light" onClick={() => setModal(false)}>Previous</button>
                                <button type="submit" className="btn btn-success" id="addNewMember" onClick={() => { toggleTab(activeTab + 1, 100); }}>{!isEdit ? "Next" : "Save"}</button>
                            </div>
                        </ModalBody>
                    </Modal>
                )}

                {activeModal === "password" && (
                    <Modal isOpen={modal} toggle={toggle} centered>
                        <ModalBody>
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <h4>Password Modification</h4>
                                <i className="bx bx-x fs-3 cursor-pointer" onClick={toggle}></i>
                            </div>
                            <div className="progress-nav mb-5 w-50 mx-auto">
                                <Progress
                                    value={progressbarvalue}
                                    style={{ height: "1px" }}
                                />

                                <Nav
                                    className="nav-pills progress-bar-tab custom-nav"
                                    role="tablist"

                                >
                                    <NavItem>
                                        <NavLink
                                            to="#"
                                            id="pills-gen-info-tab"
                                            className={classnames(
                                                {
                                                    active: activeTab === 1,
                                                    done: activeTab <= 4 && activeTab >= 0,
                                                },
                                                "rounded-pill"
                                            )}
                                            onClick={() => {
                                                toggleTab(1, 0);
                                            }}
                                            tag="button"
                                        >
                                            <div className="p-0  mt-2">1</div>
                                            <h6 className="mt-1 w-100 fw-bold ">Please verify your account
                                            </h6>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            to="#"
                                            id="pills-gen-info-tab"
                                            className={classnames(
                                                {
                                                    active: activeTab === 2,
                                                    done: activeTab <= 4 && activeTab > 1,
                                                },
                                                "rounded-pill"
                                            )}
                                            onClick={() => {
                                                toggleTab(2, 100);
                                            }}
                                            tag="button"
                                        >
                                            <div className="p-0  mt-2">2</div>
                                            <h6 className="mt-1 w-100 fw-bold ">Change the email
                                            </h6>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId={1}>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}>
                                        <p className="m-0">Your current login phone</p>
                                        <p className="m-0 py-1">+92 3242554868</p>

                                        <Label htmlFor="addressDetails" className="form-label">
                                            <p className="m-0">Verification Code in SMS</p>
                                        </Label>
                                        <div className="d-flex w-75 aling-items-center mb-">
                                            <Input
                                                type="text"
                                                name="addressDetails"
                                                className="me-2"
                                                id="addressDetails"
                                                placeholder="Enter the code"
                                            />
                                            <button type="button" className="btn btn-outline-success">Send</button>
                                        </div>
                                        <p className="text-success"><span><i className="bx bx-envelope-open"></i></span> Verify via login email address</p>

                                    </Form>


                                </TabPane>

                                <TabPane tabId={2}>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}>
                                        tab2
                                    </Form>
                                </TabPane>
                            </TabContent>
                            <div className="hstack gap-2 justify-content-end">
                                <button type="submit" className="btn btn-success" id="addNewMember" onClick={() => { toggleTab(activeTab + 1, 100); }}>{!isEdit ? "Next" : "Save"}</button>
                                <button type="submit" className="btn btn-light" id="addNewMember">{!isEdit ? "Submit" : "Save"}</button>
                            </div>
                        </ModalBody>
                    </Modal>
                )}

            </Container>
        </div>
    );
};

export default AccountSetting;
